import { type Language, links } from "@app/constants";

interface Messages {
	body: string;
	logout: string;
	proceed: string;
}

type Message = {
	[key in Language]: Messages;
};

const messages: Message = {
	en: {
		body: `<p>Welcome to Future Forex!</p>
        <p class="my-7">Thank you for registering an account with us.</p>
        <p><b>Before your investment begins, please complete our onboarding process:</b></p>
        <ol>
            <li class="my-3">Add details: <span>As an authorised Financial Services Provider (FSP #51884), we are required to collect some information from you.</span></li>
            <li class="my-3">Capitec Registration: <span>We’ll assist with opening your Capitec Business bank account, a key component of your Crypto Arbitrage investment.</span></li>
            <li class="mt-3">Investment Begins: <span>Once the onboarding process is complete, you will have access to your dashboard and can begin investing!</span></li>
        </ol>
        <p class="mt-7">If you need any help, please <a href="${links.contact}" target="_blank">contact us</a>.</p>
        `,
		logout: "LOGOUT",
		proceed: "PROCEED",
	},
};

export default messages;
